<template>
  <div id="orderFilter">
    <div class="flexer">
      <b-form-radio-group size="sm" class="pillbox" buttons button-variant="clear" v-model="status" @input="$emit('input', status)">
        <b-form-radio value="review" v-if="showReview">Review <b-badge v-if="numToReview">{{numToReview}}</b-badge></b-form-radio>
        <b-form-radio value="open">Open</b-form-radio>
        <b-form-radio value="shipped">Shipped</b-form-radio>
        <b-form-radio value="cancelled" v-if="showCancelled">Cancelled</b-form-radio>
      </b-form-radio-group>

      <b-form-radio-group v-if="showOwnershipFilters" size="sm" class="pillbox" buttons button-variant="clear" v-model="ownership">
        <b-form-radio value="mine"><i class="fas fa-user"></i> Mine</b-form-radio>
        <b-form-radio value="all"><i class="fas fa-users"></i> Team</b-form-radio>
      </b-form-radio-group>
    </div>

    <div class="noMessage" v-if="noMessage && !isBusy">{{noMessage}}</div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import orderStatus from '@/lib/orderStatus';

function yes(order) {
  return true;
}
function statusFilter(status) {
  if (!status) return yes;
  return order => orderStatus(order.status) === status;
}
function ownerFilter(id) {
  return order => order.owner === id;
}

export default {
  props: ['in', 'isBusy'],
  data() {
    return {
      ownership: 'mine',
      status: null
    }
  },
  mounted() {
    this.emit();
    if (this.user && this.user.user_type === 'admin') {
      this.ownership = 'all';
    }
  },
  watch: {
    filtered() {
      this.emit();
    },
  },
  computed: {
    ...mapGetters(['user', 'approvalEnabled']),
    showOwnershipFilters() {
      return this.user.user_type === 'admin';
    },
    showReview() {
      // Show if feature enabled, or if someone has orders
      // to review (ie, they used to have feature enabled).
      return this.numToReview > 0 || this.approvalEnabled;
    },
    showCancelled() {
      // Don't show cancelled tab, unless there are cancelled orders.
      // We don't want people solving their issues that way.
      let numCancelled = this.ownerFiltered.filter(statusFilter('cancelled')).length;
      return numCancelled > 0;
    },
    ownerFiltered() {
      return (this.in||[]).filter(this.ownerFilter());
    },
    filtered() {
      return this.ownerFiltered.filter(statusFilter(this.status));
    },
    numToReview() {
      return this.ownerFiltered.filter(statusFilter('review')).length;
    },
    noMessage() {
      if (this.filtered.length) return;
      let s = {mine: 'You have ', all: 'Team has '}[this.ownership];
      if (this.status === 'review') {
        s += 'no orders to review';
      } else if (this.status) {
        s += 'no '+this.status+' orders';
      } else {
        s += 'no orders';
      }
      return s;
    },
  },
  methods: {
    emit() {
      this.$emit('out', this.filtered);
      if (!this.status) this.chooseStatus();
    },
    ownerFilter() {
      return this.ownership === 'mine' ? ownerFilter(this.user.id) : yes;
    },
    chooseStatus() {
      // Find first tab where there are orders.
      // We don't expect to find no statuses, since
      // this component doesn't show in the no-order case.
      // However, just return null in that case.
      this.status = ['review', 'open', 'shipped', 'cancelled'].find(
        status => this.filtered.some(statusFilter(status))
      );
    }
  }
}
</script>

<style lang="scss">
@import '~scss/colors';

#orderFilter {
  width: 100%;

  .flexer {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    > .pillbox {
        padding-bottom: 1em;
    }
  }

  .noMessage {
    padding: 1em 0;
  }

  .pillbox {
    .btn-group > .btn-clear:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    .btn-group > .btn-clear:last-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    .btn-clear {
      border: 1px solid #ccc;
      padding: 8px 15px;
      height: auto;
      &.active {
        background: $gray-2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/orders/OrderFilter.vue